import { Box, useTheme } from '@mui/material';
import { useIsMobile } from 'shared/hooks';

export function useSpacerHeight() {
    const isMobile = useIsMobile();
    const theme = useTheme();

    const toolbarMinHeight = typeof (theme.mixins.toolbar.minHeight) === 'number'
        ? theme.mixins.toolbar.minHeight
        : parseInt(theme.mixins.toolbar.minHeight || '0', 10);

    return isMobile
        ? toolbarMinHeight
        : toolbarMinHeight + 48;
}

export default function Spacer() {
    const minHeight = useSpacerHeight();

    return (
        <Box sx={{ minHeight }} />
    );
}
